import { render, staticRenderFns } from "./ThreeYearResult.vue?vue&type=template&id=87ee584a&scoped=true"
import script from "./ThreeYearResult.vue?vue&type=script&lang=js"
export * from "./ThreeYearResult.vue?vue&type=script&lang=js"
import style0 from "./ThreeYearResult.vue?vue&type=style&index=0&id=87ee584a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee584a",
  null
  
)

export default component.exports